import React, {Component} from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import cx from 'classnames';

/* Loadable Libraries */
const Truncate = loadable(() => import('react-truncate'));

/* Components */
import HbButton from '../../HbButton/HbButton';

import s from './hb-collapsing-text-view.scss';

const DEFAULT_MAX_LINES = 3;

class HbCollapsingTextView extends Component {
  static propTypes = {
    className: PropTypes.string,
    contentClassName: PropTypes.string,
    buttonClassName: PropTypes.string,
    children: PropTypes.node.isRequired,
    collapseButtonText: PropTypes.string.isRequired,
    showAllButtonText: PropTypes.string.isRequired,
    maxLines: PropTypes.number.isRequired,
    isCollapsingEnabled: PropTypes.bool,
    isInitiallyCollapsed: PropTypes.bool,
  }

  static defaultProps = {
    showAllButtonText: 'Devamını Göster',
    collapseButtonText: 'Devamını Gizle',
    isCollapsingEnabled: true,
    isInitiallyCollapsed: true,
    maxLines: DEFAULT_MAX_LINES,
  }

  constructor(props) {
    super(props);
    const {
      isCollapsingEnabled,
      isInitiallyCollapsed,
    } = props;

    this.state = {
      isCollapsed: isCollapsingEnabled && isInitiallyCollapsed,
    };
  }

  handleCollapseButtonClick = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed,
    });
  }

  renderCollapseButton = (buttonText, buttonClassName) => {
    return (
      <HbButton
        className={cx(s.collapseButton, buttonClassName)}
        text={buttonText}
        onClick={this.handleCollapseButtonClick}/>
    );
  }

  render() {
    const {
      children,
      className,
      contentClassName,
      buttonClassName,
      collapsedTextHeight,
      showAllButtonText,
      collapseButtonText,
      maxLines,
      isCollapsingEnabled,
    } = this.props;

    const {isCollapsed} = this.state;

    const containerClassName = cx(
      s.root,
      isCollapsed && s.hasCollapsedText,
      className,
    );
    let contentStyles, buttonText;

    if (isCollapsed && isCollapsingEnabled) {
      buttonText = showAllButtonText;
      contentStyles = {
        maxHeight: `${collapsedTextHeight}px`,
      };
    } else {
      buttonText = collapseButtonText;
      contentStyles = {};
    }

    return (
      <div className={containerClassName}>
        <Truncate
          className={cx(s.content, contentClassName)}
          lines={isCollapsingEnabled && isCollapsed && maxLines}
          ellipsis={this.renderCollapseButton(buttonText, buttonClassName)}>
          {children}

          {!isCollapsed &&
          this.renderCollapseButton(
            buttonText,
            buttonClassName
          )}
        </Truncate>
      </div>
    );
  }
}

export default HbCollapsingTextView;
